import { Dispatch } from "redux";
import axios from "axios";
import {SmartbetTrackingActionTypes, SmartbetTrackingAction} from "../../types/SmartBet/smartbetTrackingTypes";

interface ErrorResponse {
    code: number;
    message: string;
}

export const trackingSmartbet = (code: string): any => {
    return async (dispatch: Dispatch<SmartbetTrackingAction>) => {
        try {
            dispatch({ type: SmartbetTrackingActionTypes.FETCH_SMARTBET_TRACKING_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/tickets/${code}`,
                withCredentials: false
            });
            dispatch({ type: SmartbetTrackingActionTypes.FETCH_SMARTBET_TRACKING_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: SmartbetTrackingActionTypes.FETCH_SMARTBET_TRACKING_DATA_ERROR, payload: errorPayload });
        }
    }
}
